<template>
    <p class="mt-1 text-sm/6 font-regular text-tertiary">
        <slot></slot>
    </p>
</template>
